import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MyAccountPage } from './my-account.page';
import { ApiSettingsComponent } from '../api-settings/api-settings.component';
import { AddApiSettingComponent } from '../api-settings/add-api-setting/add-api-setting.component';
import { EditApiSettingComponent } from '../api-settings/edit-api-setting/edit-api-setting.component';

const routes: Routes = [
  {
    path: '',
    component: MyAccountPage,
    data : {
      title: "My Profile"
    }

  },
  {
    path:'api-settings',
    component:ApiSettingsComponent
  },
  {
    path:'add-api',
    component:AddApiSettingComponent
  },
  {
    path:'api-details/:id',
    component:EditApiSettingComponent
  },
  {
    path:'edit-api/:id',
    component:EditApiSettingComponent
  }
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyAccountPageRoutingModule {}
